/**
 * An action option for the action button dropdown
 */
export interface ActionOption {
  /**
   * Unique identifier for this option
   */
  id: string;

  /**
   * Display label
   */
  label: string;

  /**
   * Optional Material Icon name (e.g., 'grid-view', 'view-list')
   */
  icon?: string;

  /**
   * Optional text/number to display instead of icon
   */
  displayText?: string | number;
}
